"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "banners", {
  enumerable: true,
  get: function get() {
    return _banners["default"];
  }
});
var _banners = _interopRequireDefault(require("./banners"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }